<template>
<div class="chapter">
<div class="inner_page">
<p class="ded-title"><span><i><b>To the Thursday Group</b></i></span></p>
<p class="ded1-2"><span>Heidi Boehringer, Dennis Bailey, Dorian Cirrone, Daniel Deluca, Marci Finklestein, Niki Fotopoulos, Nancy Greenberg, Christian Henz, Nancy Knutson, Joan Lankford, Chauncey Mabe, Mary Mastin, Joan Mazza, Joan McIver, Stuart McIver, Lynda Patten, Mark Peres, Carla Pittman, Bill Rea, Gloria Rothstein, Lucille Shulklapper, Mark Smith and Noreen Wald</span></p>
<p class="ded1"><span><i>Thank you all for support, inspiration and friendship</i>.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?3d042eb4